/* eslint-disable vue/valid-v-bind */
<script>
import WebLinkMixin from '@/mixins/weblink'
import IconPlay from '@/components/IconPlay.vue'
import vueSignature from 'vue-signature'
// isMenuToggle: toggleMenu()
// isModalToggle: toggleModal()
// showCover: toggleCover()

import { SELLING_REGIONS, OPPORTUNITY_TYPES_IDS } from '@/constants'

export default {
  name: 'WebLinkInsightVacations',
  mixins: [WebLinkMixin],
  data () {
    return {
      isModalTermsAndConditionsToggle: false,
      isModalBookMyGroupSuccessToggle: false,
      isModalBookMyGroupToggle: false,
      modal: 0,
      signatureBoolean: true,
      signatureName: false,
      signaturePayment: false,
      signatureCondition: false,
      signatureNumber: false,
      signatureBox: false,
      constants: {
        SELLING_REGIONS,
        OPPORTUNITY_TYPES_IDS
      }
    }
  },
  methods: {
    toggleTermsAndConditionsModal (i = 0) {
      this.modal = i === 1 ? 1 : 0
      this.isModalTermsAndConditionsToggle = !this
        .isModalTermsAndConditionsToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalTermsAndConditionsToggle
      )
      if (this.modal === 1) {
        this.toggleBookMyGroupModal()
        document.body.classList.add(
          'modal-open',
          this.isModalTermsAndConditionsToggle
        )
      }

      this.checkTermConditionScroll(this.isModalTermsAndConditionsToggle)
    },
    toggleBookMyGroupModal () {
      this.isModalBookMyGroupToggle = !this.isModalBookMyGroupToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalBookMyGroupToggle
      )

      setTimeout(() => {
        let canvas = document.querySelector('.signature-gold canvas')
        if (canvas) {
          let parentWidth = canvas.parentElement.offsetWidth
          let parentHeight = canvas.parentElement.offsetHeight
          canvas.height = parentHeight
          canvas.width = parentWidth
        }
      }, 500)
    },
    toggleBookMyGroupSuccessModal () {
      this.isModalBookMyGroupSuccessToggle = !this
        .isModalBookMyGroupSuccessToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalBookMyGroupSuccessToggle
      )
    },
    muted () {
      var video = document.getElementById('videoLoop')
      video.muted = true
    },
    handleSaveSignature () {
      this.signatureName = false
      this.signaturePayment = false
      this.signatureCondition = false
      this.signatureNumber = false
      this.signatureBox = false
      if (
        this.signature.accepted_conditions === false ||
        this.signature.name === '' ||
        this.signature.payment_amount === '' ||
        this.signature.number_of_guests === ''
      ) {
        this.message = 'All the fields are required.'
        if (this.signature.accepted_conditions === false) {
          this.signatureCondition = true
        }
        if (this.signature.name === '') {
          this.signatureName = true
        }
        if (this.signature.payment_amount === '') {
          this.signaturePayment = true
        }
        if (this.signature.number_of_guests === '') {
          this.signatureNumber = true
        }
        return false
      }
      if (this.$refs.signature.isEmpty()) {
        this.message = 'Please fill your signature.'
        this.signatureBox = true
        return false
      }
      this.signature.uuid = this.$route.params.uuid
      this.signature.accepted_conditions = 1
      this.signature.image = this.$refs.signature.save()
      this.disableButton = true
      this.message = null
      this.sendSignature(this.signature)
        .then(response => {
          if (response.data && response.status === 200 && response.data.status) {
            this.cleanForm()
            this.disableButton = true
            this.hasSignature = true
            this.toggleBookMyGroupSuccessModal()
            this.toggleBookMyGroupModal()
          } else {
            this.message = 'Something went wrong, please try again.'
            this.isSending = false
            this.isCompleted = true
            this.disableButton = false
          }
        })
        .catch(error => {
          const hasMessage = error && error.response && error.response.data && error.response.data.message
          this.message = hasMessage || 'Something went wrong, please try again.'
          this.isSending = false
          this.isCompleted = true
          if (error.response.data.hash) {
            this.hash = error.response.data.hash
          }
          this.disableButton = false
        })
        .finally(() => {})
    },
    clear () {
      var _this = this
      _this.$refs.signature.clear()
    },
    undo () {
      var _this = this
      _this.$refs.signature.undo()
    },
    cleanForm () {
      this.signature.id = null
      this.signature.parent = null
      this.signature.name = ''
      this.signature.last_name = ''
      this.signature.user_agent = ''
      this.signature.payment_amount = ''
      this.signature.traveler_email = ''
      this.signature.number_of_guests = ''
      this.signature.accepted_conditions = 0
      this.signature.image = ''
      this.clear()
    },
    handleInput (e, value) {
      if (value !== '' || value) {
        e.target.classList.remove('active')
      }
    }
  },
  components: {
    IconPlay,
    vueSignature
  },
  mounted () {
    // this.signature.traveler_email = this.data.data.email_owner
    //   ? this.data.data.email_owner
    //   : ''
    this.signature.parent = this.data.data.itineraries.id
      ? this.data.data.itineraries.id
      : ''

    this.getSignature(this.signature.parent)
  }
}
</script>

<style lang="scss" scoped>
@import './font-effra.scss';
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
</style>
<template>
  <div
    id="menu"
    class="body-page fp-viewing-home body"
    :class="{ 'modal-open': isModalToggle }"
  >
    <!-- BEGIN OF site header Menu -->
    <header
      class="page-header navbar page-header-drawer menu-right logo-left topmenu-right animated slow fadeIn hidePlease"
    >
      <!-- Begin of menu icon toggler -->
      <button
        class="navbar-toggler site-menu-icon"
        id="navMenuIcon"
        :class="{ 'menu-visible': isMenuToggle }"
        @click="toggleMenu"
        v-if="showCover"
      >
        <span
          class="menu-icon menu-icon-line"
          :class="{ 'menu-visible': isMenuToggle }"
        >
          <span
            class="text show-menu-visible"
            :class="{ 'menu-visible': isMenuToggle }"
            >Close</span
          >
          <span
            class="text hide-menu-visible"
            :class="{ 'menu-visible': isMenuToggle }"
            >Menu</span
          >
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>

      <div class="cover-tittle">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img
                v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id"
                class="light-logo"
                src="/weblinks/insight-vacations/img/logo.png"
                alt="Logo"
              />
              <img
                v-else
                class="light-logo"
                src="/weblinks/insight-vacations/img/logo2.png"
                alt="Logo"
              />
            </span>
          </a>
        </div>
      </div>

      <div
        class="all-menu-wrapper"
        id="navbarMenu"
        :class="{ 'menu-visible': isMenuToggle }"
      >
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
            <ul class="navbar-nav">
              <li class="nav-item active">
                <a
                  class="nav-link"
                  href="#home"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('home')"
                  >Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#map"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('map')"
                  >Map</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#itinerary"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('itinerary')"
                  >Itinerary</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#prices"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('prices')"
                  >Pricing</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#highlight"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('highlight')"
                  >Highlights</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#book"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('book')"
                  >Book my group</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#contact"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('contact')"
                  >Contact Us</a
                >
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->

    <!-- BEGIN OF page main content -->
    <main class="page-main main-anim scrollpage-container" id="mainpage">
      <div
        id="home"
        class="backgroundHome section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        :style="[ firstOpporunityBackgroundImage != ''
            ? {
                backgroundImage: `url('${getParsedImageUrl(
                  firstOpporunityBackgroundImage
                )}')`
              }
            : {
                'background-image':
                  'url(/weblinks/insight-vacations/img/bg-style-1.jpg)'
              }
        ]"
      >
        <div class="fullscreen-video-wrap" v-if="!showCover">
          <button
            class="button button-play"
            type="button"
            id="firstPlayVideo"
            @click="playVideo"
          ></button>
          <button
            type="button"
            class="btn btn-link animated fadeIn slow"
            id="firstSkipVideo"
            @click="skipVideo"
          >
            <div>Skip video <IconPlay /></div>
          </button>
          <div class="overlay-home"></div>
          <video
            allow="autoplay"
            preload="auto"
            playsinline
            id="videoLoop"
            class="animated fadeIn videoDesktop"
            poster="/weblinks/insight-vacations/video/video.jpg"
          >
            <source
              src="https://itereo-prod.s3.us-east-2.amazonaws.com/weblink/insight-vacations/video/intro.mp4"
              type="video/mp4"
            />
          </video>
        </div>
        <div class="section-wrapper animated delay-1s slow fadeIn">
          <div class="section-content anim">
            <div class="cover-header-description" v-show="showCover">
              <p
                class="cover-header-description-title2"
                v-if="d && d.itineraries"
              >
                {{ d.itineraries.titleitinerary }}
              </p>
              <picture>
                <img
                  :src="secondOpporunityBackgroundImage"
                  alt="Secondary image"
                />
              </picture>
            </div>

            <div
              class="btn-trip form-group form-success-gone mb-0"
              v-show="!showCover"
            >
              <button
                id="submit-email"
                name="submit_email"
                class="btn-trip_white animated fadeInDown slow animatedColor btn form-success-gone mb-0 hidePlease"
                @click="toggleCover"
              >
                <strong class="text">VIEW TOUR</strong>
              </button>
            </div>
          </div>

          <footer class="section-footer scrolldown" v-show="showCover">
            <a class="down" @click="scrollMeTo('letter')">
              <span class="icon"></span>
              <span class="txt">LETTER</span>
            </a>
          </footer>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div
        class="section fl-porto"
        data-section="letter"
        id="letter"
        v-show="showCover"
      >
        <div class="section-wrapper with-margin">
          <div class="row">
            <div class="col-12 col-md-12 text-left ">
              <!-- title and description -->
              <div class="title">
                The Art of Touring in Style.
              </div>
              <div
                class="title-desc anim-4 paddig-container"
                v-html="d.itineraries.letter_itinerary"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div
        class="section pt-5 bg-level-2"
        data-section="itinerary"
        id="itinerary"
        v-show="showCover"
      >
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle">
              <div class="title scrolled">
                Itinerary
              </div>
              <div
                class="subtitle"
                v-if="d && d.itineraries"
              >
                {{ d.itineraries.titleitinerary }}
              </div>
              <div class="cover-header-description-title4">
                <span v-if="d && d.itineraries">{{
                  d.itineraries.fromitinerary | custom-date
                }}</span>
                <span v-if="d && d.itineraries">{{
                  d.itineraries.toitinerary | custom-date
                }}</span>
                <span
                  v-if="
                    d &&
                      d.itineraries &&
                      d.itineraries.locations_visited &&
                      Array.isArray(d.itineraries.locations_visited)
                  "
                  >{{
                    d.itineraries.locations_visited | custom-join('name')
                  }}</span
                >
              </div>
            </div>
            <div class="row row-random grid-media-aside-text fade-3">
              <div
                class="col-md-4 border-card"
                v-for="(day, index) in d.itineraries.days"
                :key="index"
                @click="dayScrollTo(index)"
              >
                <div
                  class="card gallery-day"
                  data-toggle="modal"
                  data-target="#modal-fullscreen"
                >
                  <img
                    v-if="day.url_image_1200_725"
                    :src="day.url_image_1200_725"
                  />
                  <img
                    v-if="!day.url_image_1200_725"
                    src="/weblinks/insight-vacations/img/day-img.jpg"
                  />
                  <div class="info">
                    <h1>day {{ day.startday }}</h1>
                    <p class="date">
                      <span v-if="day">{{
                        day.startdate | custom-date
                      }}</span>
                    </p>
                    <p class="day__title" v-html="day.title"></p>
                    <p
                      v-if="
                        day && day.locations && Array.isArray(day.locations)
                      "
                      class="location"
                    >
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of description section -->
      <!-- <div class="section fullscreen-md-off bg-level-3 no-footer bg-mark" data-section="highlight" id="highlight" v-show="showCover"> -->
      <div
        class="section fullscreen-md-off no-footer bg-mark"
        data-section="highlight"
        id="highlight"
        v-show="showCover"
        v-if="
          (Array.isArray(d.itineraries.highlights) &&
            d.itineraries.highlights.length > 0) ||
            (Array.isArray(d.itineraries.whatsincluded) &&
              d.itineraries.whatsincluded.length > 0) ||
            (Array.isArray(d.itineraries.whatsnotincluded) &&
              d.itineraries.whatsnotincluded.length > 0)
        "
      >
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="text-left">
              <div
                class="section-info white"
                v-if="
                  Array.isArray(d.itineraries.highlights) &&
                    d.itineraries.highlights.length > 0
                "
              >
                <h1>Highlights</h1>
                <div
                  v-for="highlight in d.itineraries.highlights"
                  :key="highlight.id"
                >
                  <h3
                    class="hideInclusionTitle"
                    v-html="highlight.title"
                  ></h3>
                  <ul class="mb-4 mt-4">
                    <li
                      v-for="item in highlight.items"
                      :key="item.id"
                      v-html="item.items"
                    ></li>
                  </ul>
                </div>
              </div>

              <div
                class="section-info light-green"
                v-if="
                  Array.isArray(d.itineraries.whatsincluded) &&
                    d.itineraries.whatsincluded.length > 0
                "
              >
                <h1>What's Included</h1>
                <div
                  v-for="whatsinc in d.itineraries.whatsincluded"
                  :key="whatsinc.id"
                >
                  <h3 class="hideInclusionTitle" v-html="whatsinc.title"></h3>
                  <ul class="mb-4 mt-4">
                    <li
                      v-for="item in whatsinc.items"
                      :key="item.id"
                      v-html="item.items"
                    ></li>
                  </ul>
                </div>
              </div>

              <div
                class="section-info white pr-4"
                v-if="
                  Array.isArray(d.itineraries.whatsnotincluded) &&
                    d.itineraries.whatsnotincluded.length > 0
                "
              >
                <h1>What's not included</h1>
                <div
                  v-for="whatsnotinc in d.itineraries.whatsnotincluded"
                  :key="whatsnotinc.id"
                >
                  <h3
                    class="hideInclusionTitle"
                    v-html="whatsnotinc.title"
                  ></h3>
                  <ul class="mb-4 mt-4">
                    <li
                      v-for="item in whatsnotinc.items"
                      :key="item.id"
                      v-html="item.items"
                    ></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="section pt-5 section-register content-white"
        data-section="map"
        id="map"
        v-show="showCover"
      >
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <h2 class="title">Map</h2>
                  <div v-if="d && d.itineraries" class="subtitle">
                    {{ d.itineraries.titleitinerary }}
                  </div>
                  <p class="subtitle2 mt-4">
                    Map route is to be used as a guide for illustration purposes
                    only, and does not represent the exact path taken.
                  </p>
                </div>
              </div>

              <div class="col-12 col-md-12">
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of description section -->
      <div
        class="section pt-5 fullscreen-md-off no-footer "
        data-section="prices"
        id="prices"
        v-show="showCover"
      >
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <h2 class="title mb-4">Pricing</h2>
                </div>
                <div
                  class="white pricingtable__container"
                  v-html="d.itineraries.pricing_itinerary"
                  :class="{
                    usa: 244 == d.selling_regions[0].id,
                    'all-regions': 244 != d.selling_regions[0].id
                  }"
                ></div>
                <p class="terms">
                  View
                  <a href="#" @click.prevent="toggleTermsAndConditionsModal(0)"
                    >Terms and Conditions</a
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of Book your group section -->
      <div
        class="section pt-5 pb-5 bg-level-3"
        data-section="book"
        id="book"
        v-show="showCover"
      >
        <div class="section-wrapper pt-0 pb-5">
          <div class="section-content anim book__container">
            <div class="center-values-book">
              <div>
                <div class="title-desc m-0">
                  <h2 class="title p-0">Book my group</h2>
                </div>
                <div>
                  <div v-if="d && d.itineraries" class="subtitle mb-4">
                    {{ d.itineraries.titleitinerary }}
                  </div>
                </div>
              </div>
            </div>

            <picture class="book-image-box">
              <img
                v-if="secondOpporunityBackgroundImage != ''"
                :src="`${getParsedImageUrl(secondOpporunityBackgroundImage)}`"
                alt=""
              />
              <img
                v-else
                src="/weblinks/insight-vacations/img/day-img.jpg"
                alt=""
              />
            </picture>
            <button
              class="btn btn-outline-white form-success-gone mb-0  mt-3 button-book-signature"
              type="submit"
              @click.prevent="toggleBookMyGroupModal"
              :disabled="
                data.data.request_form.properties_request_form
                  .id_stage_supplier !== 23
              "
            >
              <strong class="text">Book this trip</strong>
            </button>
          </div>
        </div>
      </div>

      <!-- Begin of contact section -->
      <div
        class="section section-contact bg-level-2 content-white"
        data-section="contact"
        id="contact"
        v-show="showCover"
      >
        <div class="anim contact-info contact-info-left">
          <img
            v-if="thirdOpporunityBackgroundImage != ''"
            :src="`${getParsedImageUrl(thirdOpporunityBackgroundImage)}`"
            alt=""
          />
          <img
            v-else
            src="/weblinks/insight-vacations/img/bg-style-1.jpg"
            alt=""
          />
          <div>
            <div class="title-desc">
              <h2 class="display-5 anim-2 text-center">Contact us</h2>
            </div>
            <div class="contact__info">
              <h3
                class="text-center"
                v-if="!d.firstname_owner && !d.lastname_owner"
              >
                Contact your Travel Advisor or call
              </h3>
              <h3 class="text-center">
                <span v-if="d.firstname_owner">{{
                  d.firstname_owner
                }}</span>
                <span v-if="d.lastname_owner"> {{ d.lastname_owner }}</span>
              </h3>
              <h3 class="text-center">
                <strong v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id"
                  >1-888-370-2736 Option {{ d.properties_opportunity.id_opportunity_export_type === constants.OPPORTUNITY_TYPES_IDS.SCHEDULED ? "1" : d.properties_opportunity.id_opportunity_export_type === constants.OPPORTUNITY_TYPES_IDS.CUSTOM ? "2" : "" }}</strong
                >
                <strong
                  v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.GB.id"
                  >+44 20 7620 8996</strong
                >
                <strong v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.AU.id"
                  >1300 780 283</strong
                >
                <strong v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.CA.id"
                  >1-800-346-2830</strong
                >
                <strong v-else>1 888 680 1241</strong>
              </h3>
            </div>
          </div>
        </div>

        <div class="anim contact-info contact-info-right fluid py-5">
          <div class="contact-us-box">
            <div class="title-desc">
              <h2 class="display-5 anim-2">Message Us Directly</h2>
            </div>
            <form @submit.prevent="sendContactForm">
              <div class="form-group ">
                <input
                  class="form-control-white"
                  type="text"
                  required
                  placeholder="Your Name"
                  v-model="name"
                  :disabled="isSending"
                />
              </div>
              <div class="form-group ">
                <input
                  class="form-control-white"
                  type="text"
                  required
                  placeholder="Your Email"
                  v-model="email"
                  :disabled="isSending"
                />
              </div>
              <div class="form-group ">
                <textarea
                  class="form-control-white"
                  type="text"
                  required
                  placeholder="How can we assist you with this group?"
                  cols="10"
                  rows="10"
                  v-model="description"
                  :disabled="isSending"
                ></textarea>
              </div>
              <div
                class="form-group form-success-gone text-right mb-0 d-flex justify-content-start align-items-center"
              >
                <div v-if="isCompleted">{{ message }}</div>
                <button
                  class="btn btn-outline-white form-success-gone mb-0"
                  type="submit"
                  :disabled="isSending"
                >
                  <span class="text" v-if="!isSending">DISCOVER THE TOUR</span>
                  <span class="text" v-else>Sending</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <footer v-show="showCover">
        <div class="section-wrapper padding-footer ">
          <div class="powered-by-text">
            Powered by<br />
            <img
              src="/weblinks/insight-vacations/img/logo-itp.png"
              width="80"
            />
          </div>
          <div class="detail">
            All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}
          </div>
        </div>
      </footer>
    </main>

    <!-- Modal Fullscreen -- TERMS AND CONDITIONS -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-terms-and-conditions-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalTermsAndConditionsToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalTermsAndConditionsToggle"
    >
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleTermsAndConditionsModal(modal)"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog animated fadeIn">
        <div class="modal-content  ">
          <div class="modal-body">
            <div class="title-desc">
              <h3 class="h2 dark-blue pt-3 mt-2">Terms & Conditions</h3>
            </div>
            <div
              class="title-desc anim-4 paddig-container scrollable "
              v-html="d.itineraries.terms_conditions"
              @scroll="handleTCScroll"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -- MODAL BOOK MY GROUP -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-book-my-group"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalBookMyGroupToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalBookMyGroupToggle"
    >
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleBookMyGroupModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog animated fadeIn">
        <div class="modal-content  ">
          <div class="modal-body">
            <div class="title-desc">
              <h3 class="h2 dark-blue pt-3 mt-2">Book my group</h3>
            </div>
            <div
              v-if="hasSignature"
              class="mx-5 mb-0 mt-4 alert alert-success"
              role="alert"
            >
              Thank you for confirming this group with us. Please Contact Us if we can assist you further.
            </div>
            <div
              class="title-desc anim-4 py-3 px-3">
              <form
                @submit.prevent="handleSaveSignature"
                class="form-gold mt-0 px-5 py-0"
              >
                <div class="form-group">
                  <input
                    class="form-control-white"
                    type="text"
                    placeholder="Your Full Name"
                    v-model="signature.name"
                    :disabled="hasSignature"
                    :class="{ active: signatureName }"
                    @blur="handleInput($event, signature.name)"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control-white"
                    type="text"
                    placeholder="No. of seats + No. of TW & SG room type requested. E.g.: 16 pax, 7 Twins + 2 Singles"
                    v-model="signature.number_of_guests"
                    :disabled="hasSignature"
                    :class="{ active: signatureNumber }"
                    @blur="handleInput($event, signature.number_of_guests)"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control-white"
                    type="text"

                    placeholder="Deposit amount paid"
                    v-model="signature.payment_amount"
                    :disabled="hasSignature"
                    :class="{ active: signaturePayment }"
                    @blur="handleInput($event, signature.payment_amount)"
                  />
                </div>
                <div v-if="signature.user_agent === ''" :class="[ signatureBox ? 'signature-gold box-signature-div active' : 'signature-gold box-signature-div']">
                  <vueSignature
                    ref="signature"
                    :sigOption="option"
                    :w="'100%'"
                    :h="'200px'"
                  ></vueSignature>
                  <button @click="clear" class="button_clear">Clear</button>
                  <button @click="undo" class="button_undo">Undo</button>
                </div>
                <div v-else class="signature-gold">
                  <img
                    class="img-signature"
                    width="100%"
                    v-bind:src="signature.user_agent"
                  />
                </div>
                <p :class="['terms mt-2 mb-1', { active: signatureCondition }, termConditionsRead ? '' : 'disabled']" v-if="!hasSignature">
                  <input
                    type="checkbox"
                    v-model="signature.accepted_conditions"
                    name=""
                    @blur="handleInput($event, signature.accepted_conditions)"
                  />
                  Accept T&Cs
                  <a
                    href="#"
                    class="color-golden"
                    @click.prevent="toggleTermsAndConditionsModal(1)"
                    >click here</a
                  >
                </p>
                <p class="terms mt-2 hideTerms" v-else>
                  View
                  <a
                    href="#"
                    class="color-golden"
                    @click.prevent="toggleTermsAndConditionsModal(1)"
                    >Terms and Conditions</a
                  >
                </p>
                <div
                  class="form-group form-success-gone mb-3 d-flex justify-content-center align-items-center"
                >
                  <div v-if="message" class="mr-32 dangerMessage" >{{ message }}</div>
                  <button
                    class="btn btn-outline-white form-success-gone mb-0 mt-3 button-book-signature"
                    type="submit"
                    :disabled="disableButton"
                  >
                    <strong class="text">Confirm</strong>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal -- MODAL BOOK MY GROUP -->

    <!-- Modal -- MODAL SUCCESS -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-book-my-group-success"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalBookMyGroupSuccessToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalBookMyGroupSuccessToggle"
    >
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleBookMyGroupSuccessModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog animated fadeIn">
        <div class="modal-content  ">
          <div
            class="modal-body d-flex justify-content-center align-items-center"
          >
            <div class="title-desc">
              <img
                class="success-img pt-4"
                src="/weblinks/insight-vacations/img/success-img.png"
              />
              <h3 class="h2 color-golden pt-1 text-center">Success</h3>
              <div class="anim-4 text-center pb-4">
                <p>Your information was sent.</p>
                  <p>A
                    <strong class="color-golden">Group Specialist</strong>
                    will make contact with you to<br> re-confirm details by the end of the next business day.
                  </p>
                <div
                  class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center"
                >
                  <button
                    class="btn btn-outline-white form-success-gone mb-0"
                    type="submit"
                    @click="toggleBookMyGroupSuccessModal"
                  >
                    <strong class="text">Ok</strong>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal -- MODAL SUCCESS -->
    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal modal-fullscreen fade modalDays animated fadeIn"
      id="modal-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle"
    >
      <div class="section-header">
        <img
          v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id"
          class="light-logo"
          src="/weblinks/insight-vacations/img/logo.png"
          alt="Logo"
        />
        <img
          v-else
          class="light-logo"
          src="/weblinks/insight-vacations/img/logo2.png"
          alt="Logo"
        />
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content  ">
          <div class="modal-body">
            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days"
              :key="index"
            >
              <div class="row">
                <div class="col-md-6 cover-image">
                  <img
                    v-if="day.url_image_1600_900"
                    :src="day.url_image_1600_900"
                  />
                  <img
                    v-if="!day.url_image_1600_900"
                    src="/weblinks/insight-vacations/img/day-img.jpg"
                  />
                </div>
                <div class="col-md-6 section-text">
                  <div class="align-vcenter">
                    <h1>DAY {{ index + 1 }}</h1>
                    <p class="date">
                      <span v-if="day">{{
                        day.startdate | custom-date
                      }}</span>
                    </p>
                    <p class="subtittle" v-html="day.title"></p>
                    <p
                      class="location mt-2"
                      v-if="
                        day && day.locations && Array.isArray(day.locations)
                      "
                    >
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p
                      v-if="
                        day &&
                          day.textday &&
                          day.textday[0] &&
                          day.textday[0].textday
                      "
                      v-html="day.textday[0].textday"
                    ></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">ACCOMMODATION:</strong>
                      <span v-html="day.accommodation"></span>
                    </p>
                  </div>
                  <footer
                    class="section-footer scrolldownDay nextday"
                    v-if="index != Object.keys(d.itineraries.days).length - 1"
                  >
                    <a class="down" @click="scrollMeDay(`day${index + 1}`)">
                      <span class="txt"
                        >DAY {{ Number(day.startday) + 1 }}</span
                      >
                    </a>
                  </footer>
                  <footer class="section-footer scrolldownDay nextday" v-else>
                    <a class="down" @click="scrollMeDay('day0')">
                      <span class="txt">DAY 1</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
